function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import { nanoid } from 'nanoid';
import { useForwardedRef } from '@deephaven/react-hooks';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A simple checkbox component. Automatically generates an id so htmlFor/id attributes are unique.
 */
var Checkbox = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  var _props$checked = props.checked,
    checked = _props$checked === void 0 ? false : _props$checked,
    children = props.children,
    className = props.className,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    inputClassName = props.inputClassName,
    _props$isInvalid = props.isInvalid,
    isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid,
    labelClassName = props.labelClassName,
    name = props.name,
    onChange = props.onChange,
    dataTestId = props['data-testid'];
  var _useState = useState(nanoid()),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var ref = useForwardedRef(forwardedRef);
  useEffect(function setIndeterminateProperty() {
    if (ref.current) {
      // indeterminate is not actually an html attr, can only be set via JS
      ref.current.indeterminate = checked === null;
    }
  }, [ref, checked]);
  var handleOnChange = useCallback(event => {
    if (ref.current) {
      // ref.current can be null in tests, doesn't impact behaviour
      ref.current.indeterminate = checked === null;
    }
    if (onChange) {
      onChange(event);
    }
  }, [ref, checked, onChange]);
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('custom-control custom-checkbox', className),
    children: [/*#__PURE__*/_jsx("input", {
      type: "checkbox",
      ref: ref,
      checked: checked !== null && checked !== void 0 ? checked : false // checked attr must always have a value to remain as a controlled component
      ,
      className: classNames('custom-control-input', inputClassName, {
        'is-invalid': isInvalid
      }),
      disabled: disabled,
      id: id,
      name: name,
      onChange: handleOnChange,
      "data-testid": dataTestId
    }), /*#__PURE__*/_jsx("label", {
      className: classNames('custom-control-label', labelClassName),
      htmlFor: id,
      children: children
    })]
  });
});

// Forward ref causes a false positive for display-name in eslint:
// https://github.com/yannickcr/eslint-plugin-react/issues/2269
Checkbox.displayName = 'Checkbox';
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map